import {get, post, postJson} from './axios'

// 核心数据
export const getCoreData = p => get('/home/order/statistics', p);

// 公告
export const getNotice = p => get('/home/sysNotice/page', p);

// 获取首页(自营) 核心数据
export const getBusinessCoreData = p => get('/home/ownBusinessCoreData', p);

// 最近一次精准营销效果分析
export const getMarketingLast = p => get('/home/precision-marketing/last', p);

// 首页精准营销效果（查看更多）
export const precisionMore = p => get('/home/precision-marketing/more', p);

// 首页-获取首页轮播图
export const getHomeGetCarousel = p => get('/home/homeGetCarousel', p);

// 提交调查问卷
export const submitQuestionnaire = p => postJson('/home/commit-questionaire', p);

// 提交调查问卷
export const inspectQues = p => get('/home/is-commit-questionaire', p);

//首页客户转化分析，图表数据
export const customerConversion = p => get('/rfm-analyse/customerConversion', p);

//版本权限判定，判断当前版本是否有常规催付功能
export const versionPermissions = p => get('/seller/front/versionPermissions', p);

// 年度报表 2022
// export const getAnnualReport = p => get(`/annualReport/getAnnualReport`, p)
// 年度报表 2023
export const getAnnualReport = p => get(`/annualReport/getAnnualReport2023`, p)

//进入首页调用
export const getPrecisionJdSuffixListHome = p => get(`/precisionJdSuffix/getPrecisionJdSuffixList`,p);